import { organizationSelector, statusesNS, statusesSlice, statusesApi } from 'Pages/advertisement'
import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler } from 'Modules'

function* getFilterStatuses(action: statusesNS.GetFilterStatuses) {
	try {
		const tab = yield* select(organizationSelector.selectActiveTab)
		const res = yield* call(statusesApi.getFilterStatuses, tab)
		yield* put(statusesSlice.actions.setFilterStatuses(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
export function* statusesSaga() {
	yield* takeLatest(statusesSlice.actions.getFilterStatuses.type, getFilterStatuses)
}
